// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"50e1798f","732":"9d7eb023","977":"2ac7c536"}[chunkId] + ".chunk.js";
};